import { MenuDivider as BlueprintMenuDivider } from '@blueprintjs/core';
import * as React from 'react';

import { NavbarMenuItems } from 'bones/components/molecules/Navbar/types';
import { MenuItem } from 'bones/design-system/components/select/MenuItem';
import { MenuItems } from 'bones/design-system/components/select/MenuItems';

export interface NavbarMenuProps {
  menuItems?: NavbarMenuItems;
}

export const NavbarMenu: React.VFC<NavbarMenuProps> = ({ menuItems }) => {
  return (
    <MenuItems>
      {menuItems?.map(({ divider, key, items }, menuIdx) => (
        <React.Fragment key={key || menuIdx}>
          {menuIdx || divider ? (
            <BlueprintMenuDivider className="vb-menu-divider" title={divider} />
          ) : null}
          {items.map((menuItem) => (
            <MenuItem
              key={menuItem.key || menuItem.testId}
              leftIcon={menuItem.icon}
              onClick={menuItem.onClick}
              testId={menuItem.testId}
              text={menuItem.label}
            />
          ))}
        </React.Fragment>
      ))}
    </MenuItems>
  );
};
